/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiArchiveAndDeleteRoomResponseFromJSON(json) {
    return StreemApiArchiveAndDeleteRoomResponseFromJSONTyped(json, false);
}
export function StreemApiArchiveAndDeleteRoomResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nonExpertRoomParticipantDeactivated': !exists(json, 'non_expert_room_participant_deactivated') ? undefined : json['non_expert_room_participant_deactivated'],
    };
}
export function StreemApiArchiveAndDeleteRoomResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'non_expert_room_participant_deactivated': value.nonExpertRoomParticipantDeactivated,
    };
}
//# sourceMappingURL=StreemApiArchiveAndDeleteRoomResponse.js.map